import * as React from 'react'

import { useMRemoveCartItems } from '~graphql/generated/clientGraphql'

import { TCartItem } from '../types'

type TRemoveCartItemsOptions = { cartItems: RoA<Pick<TCartItem, 'id'>> }

/**
 * Hook for removing multiple cart items that uses the MRemoveCartItems mutation.
 */
export const useRemoveCartItems = () => {
  const [mRemoveCartItems, removeResult] = useMRemoveCartItems()

  /**
   * Removes multiple cart items.
   */
  const removeCartItems = React.useCallback(
    ({ cartItems }: TRemoveCartItemsOptions) => {
      mRemoveCartItems({
        variables: {
          itemIds: cartItems.map((item) => item.id),
        },
      })
    },
    [mRemoveCartItems],
  )
  return { removeCartItems, removeResult }
}
